
import GalleryEdit from "../../../assets/duotone/GalleryEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryEditIcon({ className, dataTestid = "GalleryEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
